import { Box, Typography, useTheme } from "@mui/material";
import coverImage from "../../../media/images/headCover.svg";
import AuthFooter from "../../layout/AuthLayout/Footer";
import MobileHeader from "../../layout/AuthLayout/MobileHeader";
import ArrowTickLeft from "../../../media/images/icons/arrow-tick-left";
import { useNavigate } from "react-router-dom";
export const rules = [
  {
    title: "ماده ۱ – تعاریف",
    description: [
      "«سامانه» یا «کارن ترابر نت»: بستر الکترونیکی اعلام بار و مدیریت حمل‌ونقل جاده‌ای کالا.",
      "«کاربر»: هر شخص حقیقی یا حقوقی که به‌عنوان راننده، صاحب کالا یا شرکت حمل‌ونقل در سامانه ثبت‌نام نموده است.",
      "«بار»: هر نوع محموله مجاز جهت حمل جاده‌ای که اطلاعات آن در سامانه درج می‌گردد.",
      "«بارنامه»: سند رسمی حمل‌ونقل صادره مطابق مقررات سازمان راهداری.",
    ],
  },
  {
    title: "ماده ۲ – مقررات عمومی",
    description: [
      "کلیه کاربران مکلف به رعایت قوانین و مقررات جاری کشور، از جمله آیین‌نامه‌های سازمان راهداری و حمل‌ونقل جاده‌ای، می‌باشند.",
      "ثبت‌نام و استفاده از سامانه منوط به ارائه اطلاعات صحیح و به‌روز هویتی، ثبتی و وسیله نقلیه است. مسئولیت صحت اطلاعات بر عهده کاربر خواهد بود.",
      "کارن ترابر نت صرفاً نقش بستر ارتباطی و تسهیل‌گر دارد و هیچ‌گونه تعهدی نسبت به تعهدات مالی یا قراردادی فی‌مابین کاربران ندارد.",
      "هرگونه اقدام خلاف قانون، از قبیل ثبت بار غیرمجاز، جعل اسناد، ارائه اطلاعات نادرست یا تبانی خارج از سامانه، تخلف محسوب و موجب مسدودسازی حساب کاربری و پیگرد قانونی خواهد شد.",
    ],
  },
  {
    title: "ماده ۳ – تعهدات صاحبان کالا",
    description: [
      "صاحب کالا مکلف است اطلاعات بار (نوع، وزن، ارزش، شرایط حمل و ...) را به‌صورت صحیح و کامل در سامانه درج نماید.",
      "صاحب کالا متعهد است از ثبت هرگونه کالای ممنوعه یا غیرمجاز خودداری نماید؛ در غیر این‌صورت مسئولیت قانونی و کیفری بر عهده وی خواهد بود.",
      "پرداخت کلیه هزینه‌های حمل مطابق بارنامه و توافقات صورت‌گرفته الزامی است.",
      "در صورت لغو بار پس از اعزام ناوگان، صاحب کالا مکلف به جبران هزینه‌های متعارف راننده خواهد بود.",
      "هرگونه خسارت ناشی از ارائه اطلاعات خلاف واقع یا عدم ایمن‌سازی محل بارگیری و تخلیه، بر عهده صاحب کالا خواهد بود.",
    ],
  },
  {
    title: "ماده ۴ – تعهدات رانندگان",
    description: [
      "راننده مکلف است با مدارک معتبر (گواهینامه، کارت هوشمند, معاینه فنی و ...) در سامانه فعالیت نماید.",
      "حمل بار باید صرفاً مطابق اطلاعات درج‌شده در سامانه و بارنامه صادره انجام گیرد.",
      "راننده حق واگذاری یا انتقال بار به غیر را بدون هماهنگی و ثبت در سامانه ندارد.",
      "راننده مسئول هرگونه تأخیر، تخلف رانندگی یا خسارت وارده به محموله ناشی از قصور یا تقصیر خود خواهد بود.",
      "راننده مکلف است پس از تخلیه بار، وضعیت حمل را در سامانه ثبت و مستندات لازم را ارائه نماید.",
      "رعایت اصول حرفه‌ای، اخلاقی و احترام به صاحبان کالا و شرکت‌های حمل‌ونقل الزامی است.",
    ],
  },
  {
    title: "ماده ۵ – تعهدات شرکت‌های حمل‌ونقل",
    description: [
      "شرکت‌های حمل‌ونقل موظف به ثبت بارهای مجاز و معرفی رانندگان و ناوگان واجد شرایط با مدارک معتبر می‌باشند.",
      "هرگونه دستکاری در اطلاعات بار، ثبت بار صوری یا معرفی ناوگان فاقد شرایط قانونی تخلف محسوب می‌شود.",
      "شرکت‌ها مکلف به تسویه کرایه‌ها و هزینه‌ها طبق بارنامه و قوانین جاری کشور هستند.",
      "در صورت بروز اختلاف، شرکت موظف به همکاری با سامانه و مراجع ذی‌صلاح خواهد بود.",
    ],
  },
  {
    title: "ماده ۶ – مسئولیت‌ها و محدودیت‌ها",
    description: [
      "سامانه کارن ترابر نت مسئولیتی در قبال اختلافات مالی و قراردادی میان کاربران ندارد.",
      "کلیه تعاملات مالی و عملیاتی می‌بایست در بستر سامانه صورت گیرد؛ توافقات خارج از سامانه از شمول مسئولیت کارن ترابر نت خارج است.",
      "سامانه مجاز است در صورت احراز تخلف یا مغایرت اطلاعات، دسترسی کاربر را محدود یا مسدود نماید.",
    ],
  },
  {
    title: "ماده ۷ – حل اختلاف",
    description: [
      "در صورت بروز اختلاف میان کاربران، ابتدا موضوع از طریق پشتیبانی و کمیته داخلی کارن ترابر نت بررسی می‌شود.",
      "در صورت عدم حصول توافق، مرجع صالح رسیدگی، مراجع قضایی ذیصلاح در جمهوری اسلامی ایران خواهد بود.",
    ],
  },
  {
    title: "ماده ۸ – پذیرش و به‌روزرسانی مقررات",
    description: [
      "ثبت‌نام و هرگونه استفاده از سامانه کارن ترابر نت به منزله پذیرش کامل و بدون قید و شرط کلیه مقررات مندرج در این سند است.",
      "کاربران مکلف‌اند همواره آخرین نسخه مقررات و شرایط سامانه را مطالعه و رعایت نمایند. تداوم استفاده از خدمات پس از هرگونه اصلاح یا به‌روزرسانی مقررات، به منزله قبول ضمنی و قطعی تغییرات خواهد بود.",
      "عدم آگاهی یا بی‌اطلاعی کاربر از تغییرات، رافع مسئولیت وی نخواهد بود.",
    ],
  },
];

export default function TermsPage() {
  const theme = useTheme();

  const navigate = useNavigate();
  return (
    <>
      <MobileHeader>
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
          }}
        >
          <Typography
            onClick={() => navigate("/")}
            sx={{
              cursor: "pointer",
              color: "secondary.main",
              fontWeight: 700,
              fontSize: "16px",
            }}
          >
            کارن ترابر نت
          </Typography>
          <ArrowTickLeft color={theme.palette.textColor.main} size={14} />
          <Typography
            sx={{
              color: "secondary.main",
              fontSize: "14px",
              fontWeight: 700,
            }}
          >
            قوانین و مقررات
          </Typography>
        </Box>
      </MobileHeader>

      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          paddingX: "8px",
          gap: "12px",
        }}
      >
        <Box
          sx={{
            backgroundImage: `
          linear-gradient(0deg, rgba(211, 134, 39, 0.97) 46.43%, rgba(239, 183, 114, 0.81) 135.27%),
            url(${coverImage})`,
            backgroundRepeat: "no-repeat",
            backgroundSize: "cover",
            backgroundPosition: "center",
            display: "flex",
            flexDirection: "column",
            borderRadius: "20px",
            gap: "4px",
            justifyContent: "end",
            paddingX: "16px",
            boxShadow: "0px 4px 6px 0px rgba(0, 0, 0, 0.20)",
          }}
        >
          <Typography
            sx={{
              marginTop: "60px",
              color: "#fff",
              fontSize: "24px",
              fontWeight: "700",
            }}
          >
            قوانین و مقررات
          </Typography>
          <Typography
            sx={{
              marginBottom: "16px",
              fontSize: "14px",
              fontWeight: "700",
              color: "#fff",
            }}
          >
            آخرین بروزرسانی: 1 شهریور ۱۴۰3{" "}
          </Typography>
        </Box>

        <Box
          sx={{
            flex: 1,
            borderRadius: "20px",
            padding: "12px",
            backgroundColor: theme.palette.bgColor.blueGrey50,
          }}
        >
          <Typography
            sx={{
              fontSize: "18px",
              fontWeight: "700",
              color: "primary.main",
              textAlign: "center",
              width: "70%",
              mx: "auto",
            }}
          >
            مقررات و شرایط استفاده از سامانه بازارگاه کارن ترابر نت :{" "}
          </Typography>

          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              marginTop: "12px",
              gap: "16px",
            }}
          >
            <Box>
              <Typography
                sx={{
                  fontSize: "14px",
                  fontWeight: "600",
                  textAlign: "justify",
                }}
              >
                این مقررات به‌منظور تنظیم روابط حقوقی میان صاحبان کالا، رانندگان
                وسایل نقلیه باری، شرکت‌های حمل‌ونقل و سامانه کارن ترابر نت تدوین
                گردیده و ثبت‌نام یا استفاده از خدمات سامانه به منزله قبول و
                التزام قطعی کاربران به مفاد این سند است.
              </Typography>
            </Box>
            <Box
              sx={{
                display: "flex",
                flexDirection: "column",
                gap: "8px",
              }}
            >
              {rules.map((item) => (
                <Box>
                  <Typography
                    sx={{
                      fontSize: "16px",
                      fontWeight: "700",
                    }}
                  >
                    {item.title}
                  </Typography>
                  {item.description.map((desc, index) => (
                    <Typography
                      sx={{
                        fontSize: "14px",
                        fontWeight: "600",
                        textAlign: "justify",
                      }}
                    >
                      {index + 1}-{desc}
                    </Typography>
                  ))}
                </Box>
              ))}
            </Box>
          </Box>
        </Box>
      </Box>
      <AuthFooter />
    </>
  );
}
